module.exports = "function getRowHeight ({ index }) {\n  return itemArray[index].type === 'header' ? 20 : 30\n}\n\nfunction renderList (listProps) {\n  return (\n    <List\n      rowCount={itemArray.length}\n      rowHeight={getRowHeight}\n      {...listProps}\n    />\n  )\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/dynamic-row-height-getter.js
 ** module id = 367
 ** module chunks = 0
 **/